 
import { BaseURL } from "../components/healper/apiConstant";

export const login = BaseURL + 'login';
export const register = BaseURL + 'register';
export const checkuser = BaseURL +'@me';
export const logoutuser = BaseURL + 'logout';
export const forgotpassword = BaseURL + 'resetpassword';
export const sendmailforgotpass = BaseURL + 'sendmailforgotpass';
export const verifyEmail = BaseURL + 'verifyemail';
export const changepass = BaseURL + 'changepass'